module.exports = __webpack_public_path__ + "img/thumb_image2.f9742f50.jpg";